/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSettingRequest
 */
export interface UpdateSettingRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSettingRequest
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSettingRequest
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateSettingRequest
     */
    group: string;
}

/**
 * Check if a given object implements the UpdateSettingRequest interface.
 */
export function instanceOfUpdateSettingRequest(value: object): value is UpdateSettingRequest {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('group' in value) || value['group'] === undefined) return false;
    return true;
}

export function UpdateSettingRequestFromJSON(json: any): UpdateSettingRequest {
    return UpdateSettingRequestFromJSONTyped(json, false);
}

export function UpdateSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSettingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
        'group': json['group'],
    };
}

export function UpdateSettingRequestToJSON(json: any): UpdateSettingRequest {
    return UpdateSettingRequestToJSONTyped(json, false);
}

export function UpdateSettingRequestToJSONTyped(value?: UpdateSettingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': value['value'],
        'group': value['group'],
    };
}

